export const LogoMark = ({ className = "w-10 h-10" }) => (
  <img src="/brand/logo.webp" alt="" aria-hidden="true" className={`${className} object-contain rounded-md drop-shadow-[0_0_10px_rgba(31,209,255,0.45)]`} />
);

export const Logo = () => (
  <span className="flex items-center gap-2.5 min-w-0">
    <LogoMark className="w-11 h-11 shrink-0" />
    <span className="leading-none hidden min-[430px]:block">
      <span className="font-wide text-[10px] tracking-[0.45em] text-white block">DEEJAY</span>
      <span className="font-heavy text-xl block tracking-wide mt-0.5"><span className="text-[#1FD1FF]">T-</span>REX</span>
    </span>
  </span>
);
